import {MediaCategory, StoredMediaCategory} from "../../../types/Media";
import React, {useMemo} from "react";
import IconButton from "../../../components/IconButton";
import {faEdit, faTrash} from "@fortawesome/free-solid-svg-icons";
import ApiServiceV2 from "../../../services/ApiServiceV2";
import {routes} from "../../../hooks/routes";
import MultiLanguageIcon from '../../../components/MultiLanguageIcon';
import {useGlobalContext} from "../../../contexts/globalContext";


type CategoryListItemProps = {
    parent: StoredMediaCategory | null;
    tree: StoredMediaCategory[];
    openEditModal: (category: StoredMediaCategory) => void
    openDeleteModal: (category: StoredMediaCategory) => void
    paddingLeft: number
    fetchCategories: () => void
}

const CategoryListItem: React.FC<CategoryListItemProps> = (
    {
        parent,
        tree,
        openEditModal,
        openDeleteModal,
        paddingLeft,
        fetchCategories
    }
) => {
    const { plugin } = useGlobalContext();
    const api = new ApiServiceV2()

    const children: StoredMediaCategory[] = useMemo(() => {
        return tree
            .filter((node) => {
                if (parent) return node.parent_id === parent.id;
                else return node.parent_id === 0;
            })
            .sort((a, b) => a.name.localeCompare(b.name));
    }, [parent, tree])

    const onMultiLanguageChange = (property: string, value: string) => {
        if (parent) {
            const data = {
                ...parent,
                [property]: value
            } as MediaCategory

            api.callApi(routes['mediaCategories'] + `/${data.id}`, 'post', data).then(() => {
                fetchCategories()
            })
        }
    }

    return (
        <>
            {parent && <tr key={parent.id}>
                <td style={{paddingLeft: paddingLeft+'rem'}}>{parent.name}</td>
                <td>{parent.media_count}</td>
                <td>
                    <div className={'d-flex'}>
                        <IconButton
                            icon={faTrash}
                            color={"black"}
                            onClick={() => openDeleteModal(parent)}
                        />
                        <IconButton
                            icon={faEdit}
                            color={"black"}
                            onClick={() => openEditModal(parent)}
                        />
                        {(plugin && plugin.languages && plugin.languages.length > 0) && (
                            <MultiLanguageIcon
                                property={'name_multi'}
                                onMultiLanguageChange={onMultiLanguageChange}
                                multiLanguageValue={parent.name_multi}
                            />
                        )}
                    </div>
                </td>
            </tr>}
            {children.map((child) => (
                <CategoryListItem
                    paddingLeft={paddingLeft + 1}
                    key={child.id}
                    parent={child}
                    tree={tree}
                    openEditModal={openEditModal}
                    openDeleteModal={openDeleteModal}
                    fetchCategories={fetchCategories}
                />
            ))}
        </>
    )
}

export default CategoryListItem
